import React, { useState } from "react";
import { useSpring, animated, easings } from "react-spring";

import iconPlus from '../../Images/IconPlus.svg'
import iconMinus from '../../Images/IconMinus.svg'
import ThumbUpAltOutlinedIcon from "@mui/icons-material/ThumbUpAltOutlined";
import ThumbDownAltOutlinedIcon from "@mui/icons-material/ThumbDownAltOutlined";

import {

    SyncOutlined,

} from "@ant-design/icons";

const Pakages = (props) => {

    const { showMaximumChat, msg, updateMessage, handelThum } = props

    const [toggleListIcons, setToggleListIcons] = useState({});

    const fadeInProps = useSpring({
        from: { opacity: Math.random() },
        to: { opacity: 1 },
        config: { duration: 1000, easing: easings.easeInOut },
        // Adjust duration and easing as needed
    });

    const handleToggle = (index) => {
        setToggleListIcons((prevState) => ({
            ...prevState,
            [index]: !prevState[index],
        }));
    };
    const renderList = (msg) => {
        const pack = msg?.packages;
        const data = msg?.llm_response
        const firstColumnWidth = showMaximumChat ? '35%' : '50%';
        const otherColumnWidth = showMaximumChat ? '20%' : '25%';
        return (
            <div className="channel-list">
                {pack?.length > 0 && pack.map((item, index) => {
                    const isToggled = toggleListIcons[index];
                    return (
                        <div key={index}>
                            <div
                                style={{
                                    height: showMaximumChat && '28px',
                                    borderRadius: isToggled ? '8px 8px 0px 0px' : '8px',
                                    marginBottom: !isToggled && '16px',
                                    padding: isToggled ? '16px 16px 0px 16px' : '16px'
                                }}
                                className="channel-list-head"
                            >
                                <div>
                                    <p className="channel-list-heading">{item.type}</p>
                                    {!showMaximumChat && <span className="channel-list-count">{item.channelCount} Channels</span>}
                                </div>
                                <div style={{ display: 'flex', gap: '4px' }}>
                                    {showMaximumChat && <span className="channel-list-count">{item.channelCount} Channels</span>}
                                    <img
                                        style={{ height: '26px', width: '24px', top: showMaximumChat ? '' : '-15px', position: 'relative' }}
                                        key={'plus'}
                                        src={isToggled ? iconMinus : iconPlus}
                                        onClick={() => handleToggle(index)}
                                    />
                                </div>
                            </div>
                            {isToggled &&
                                <div className="list-of-channels">
                                    <table>
                                        <thead>
                                            <tr style={{ display: 'flex' }}>
                                                <th className="coloum-name" style={{ width: firstColumnWidth }}>Channel Name</th>
                                                <th className="coloum-name" style={{ width: otherColumnWidth }}>Price</th>
                                                <th className="coloum-name" style={{ width: otherColumnWidth }}>SD/HD</th>
                                                {showMaximumChat && <th className="coloum-name" style={{ width: otherColumnWidth }}>Channel No</th>}
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {item.channels.map((channel, i) => (
                                                <tr key={i} style={{ display: 'flex' }}>
                                                    <td className="coloum-details" style={{ width: firstColumnWidth }}>{channel.name}</td>
                                                    <td className="coloum-details" style={{ width: otherColumnWidth }}>{channel.price}</td>
                                                    <td className="coloum-details" style={{ width: otherColumnWidth }}>{channel.quality}</td>
                                                    {showMaximumChat && <td className="coloum-details" style={{ width: otherColumnWidth }}>{channel.channelNumber}</td>}
                                                </tr>
                                            ))}
                                        </tbody>
                                        {/* <tbody>
                                            {Object.keys(data).map((channelName, index) => (
                                                <tr key={index}>
                                                    <td>{channelName}</td>
                                                    <td>{data[channelName].Price}</td>
                                                    <td>{data[channelName].HD_OR_SD}</td>
                                                    <td>Ch. {data[channelName].EPG_Number}</td>
                                                </tr>
                                            ))}
                                        </tbody> */}
                                    </table>
                                </div>}
                        </div>
                    );
                })}
            </div>
        );
    };
    return (
        <div className="server-text-response-body">


            <div className="channel-list-reponse" style={{ color: '#220046' }}>{msg.message}</div>
            {!msg?.Reason && renderList(msg)}
            <div
                className="server-response-footer"
                style={fadeInProps}
            >
                <div
                    style={{
                        display: "flex",
                        cursor: 'pointer',
                        ...fadeInProps,
                    }}
                >
                    <SyncOutlined
                        style={{ marginRight: 4 }}
                    />
                    <span onClick={() => { updateMessage(msg) }}>Regenerate</span>
                </div>
                <div style={{ display: 'flex' }}>
                    {showMaximumChat && <div className="version" >Version 4.2 ( Updated on 23 May 2024 )</div>}
                    <div style={fadeInProps}>
                        <ThumbUpAltOutlinedIcon
                            style={{
                                color: "#D02F92", fontSize: '15px',
                                marginTop: '12px', marginRight: 4,
                            }}
                        />
                        <ThumbDownAltOutlinedIcon
                            style={{
                                color: "#D02F92",

                                fontSize: '15px',
                                marginTop: '12px',
                            }}
                            onClick={() => handelThum()}
                        />

                    </div>
                </div>
            </div>
        </div>
    )
}

export default Pakages
